import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import {
    getIsBogRestricted,
} from '~shared/utils/user';
import { getBrandTranslationsKey } from '~shared/locales/utils/utils';

import { bannerConfigs } from './constants';

import './styles.scss';

const Banners = ({ selectionDetails }) => {
    if (isEmpty(selectionDetails)) {
        return null;
    }

    const [t] = useTranslation();

    const {
        sport,
        bog_singles,
        bog_multiples,
        boosted_odds,
    } = selectionDetails;

    const isBogUser = !getIsBogRestricted();
    const isBogSelection = bog_singles || bog_multiples;
    const showableBanners = {
        showBogBanner: isBogSelection && isBogUser,
        showBoostedOddsBanner: Boolean(boosted_odds),
        show888SpecialsBanner: sport === '888-special',
    };

    const selectionBannerClass = 'fullslip__selection-banner';
    const bannerIconClass = 'fullslip__banner-icon';

    const banners = bannerConfigs
        .filter(({conditionKey}) => showableBanners[conditionKey])
        .map(({conditionKey, iconClass, translationKey}) => {
            let title = t(translationKey);
            if (sport === '888-special') {
                const brandedSpecials = getBrandTranslationsKey('specials');
                const specials = t(`specials.${brandedSpecials}`);
                title = t('specials.title', {specials});
            }

            return (
                <li
                    key={conditionKey}
                    className={selectionBannerClass}
                >
                    <i className={classNames(iconClass, bannerIconClass)}>
                    </i>
                    {title}
                </li>
            );
        });

    return banners.length
        ? <ul className="fullslip__banners">
            { banners }
        </ul>
        : null;
};

Banners.propTypes = {
    selectionDetails: PropTypes.object.isRequired,
};

export default Banners;
